// List of attributes that gets combined from more sources before sending to Odoscope and needs to be merged into one value
export default ['pim_brand'];
